import { getLabelMessage } from '@gef-ui/localization/messages';
import TriangleExclamationSolid from '@gef-ui/material-icons/TriangleExclamationSolid';
import { AppbarButton } from '@gef-ui/material/components/Appbar';
import Badge from '@mui/material/Badge';
import Collapse from '@mui/material/Collapse';
import React, { useMemo } from 'react';
import { showErrorMultiple } from '../../actions';
import { useErrorContext, useErrorDispatch } from '../../context';
export const ErrorAppbarButton = (props)=>{
    const { errors } = useErrorContext();
    const errorContextDispatch = useErrorDispatch();
    const errorsCount = useMemo(()=>errors?.filter(({ hidden })=>!hidden).length, [
        errors
    ]);
    return /*#__PURE__*/ React.createElement(Collapse, {
        orientation: "horizontal",
        in: errorsCount > 0,
        mountOnEnter: true,
        unmountOnExit: true
    }, /*#__PURE__*/ React.createElement(AppbarButton, {
        onClick: ()=>{
            errorContextDispatch(showErrorMultiple());
        },
        title: getLabelMessage('errors:notifierTitle'),
        ...props
    }, /*#__PURE__*/ React.createElement(Badge, {
        showZero: true,
        badgeContent: errorsCount,
        color: errorsCount === 0 ? 'default' : 'error'
    }, /*#__PURE__*/ React.createElement(TriangleExclamationSolid, null))));
};
export default ErrorAppbarButton;
